import { useNavigate } from "react-router-dom";
import notify from "../components/common/notify";
import { useDiscardProjectMutation } from "../redux/slices/api/projectsApiSlice";
import { useLazyGetUserQuery } from "../redux/slices/api/userApi";
import { handleError } from "./useApi";

const useDiscardProject = (props) => {
  const [discardProject, args] = useDiscardProjectMutation();
  const [triggerGetUser] = useLazyGetUserQuery();
  const navigate = useNavigate();

  const handleDiscardProject = async (id) => {
    try {
      let res = await discardProject({
        id,
      }).unwrap();
      notify(res?.message, "success");
      await triggerGetUser().unwrap();
      if (props?.onSuccess) props.onSuccess();
      navigate("/profile#projects");
    } catch (error) {
      handleError(error, null, true);
    }
  };
  return { handleDiscardProject, ...args };
};

export default useDiscardProject;
